export const customize = {
    form: {
        title: 'CUSTOMIZE_FORM.TITLE',
        point1: 'CUSTOMIZE_FORM.POINT_1',
        point2: 'CUSTOMIZE_FORM.POINT_2',
        point3: 'CUSTOMIZE_FORM.POINT_3'
    },
    url: 'CUSTOMIZE_URL',
    domain: 'CUSTOMIZE_DOMAIN.DEFAULT',
    domainDescription: 'CUSTOMIZE_DOMAIN.DESCRIPTION'
};
